<template>
  <Admin style="background: #f2f2f2">
    <v-main v-if="!isProductListLoading">
      <v-container v-if="!selectedCompanyProductList?.isNsThaiSmartTax" fluid>
        You are not allowed for this feature, Please contact Sales
        <a href="tel:026637895" target="_blank"><b><u>026637895</u></b></a>
      </v-container>
      <v-container v-else fluid>
        <v-card class="rounded-xl tw-min-h-80">
          <v-card-text v-if="!selectedCompany.isDemo">
            <v-breadcrumbs :items="breadcrumbItems">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
              <template v-slot:item="{ item }">
                <v-breadcrumbs-item
                  :to="item.to"
                  :disabled="item.disabled"
                  :exact="true"
                >
                  {{ item.text }}
                </v-breadcrumbs-item>
              </template>
            </v-breadcrumbs>

            <div class="tw-mx-5 tw-font-bold tw-text-xl tw-text-black tw-tracking-wide">
              เพิ่มปีบัญชี
            </div>

            <div class="tw-mx-5 tw-mt-2 tw-text-sm tw-text-gray-500">
              Company: {{ selectedCompany.name || companyId }}
            </div>

            <!-- Form -->
            <v-row class="tw-mx-4 tw-mt-4">
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model.number="startYear"
                  label="ปีเริ่มต้น (ค.ศ.)"
                  type="number"
                  outlined
                  dense
                  :disabled="isLoading"
                />
              </v-col>
              <v-col cols="12" sm="4">
                <v-select
                  v-model="numYears"
                  :items="numYearsOptions"
                  label="จำนวนปี"
                  outlined
                  dense
                  :disabled="isLoading"
                />
              </v-col>
            </v-row>

            <!-- Action Buttons -->
            <v-row class="tw-mx-4">
              <v-col cols="auto">
                <v-btn
                  color="primary"
                  outlined
                  @click="handlePreview"
                  :disabled="isLoading"
                >
                  <v-icon left>mdi-magnify</v-icon>
                  Preview
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="success"
                  @click="handleUpload"
                  :disabled="isLoading"
                  :loading="isLoading"
                >
                  <v-icon left>mdi-upload</v-icon>
                  Generate & Upload
                </v-btn>
              </v-col>
            </v-row>

            <!-- Status -->
            <v-row class="tw-mx-4" v-if="statusMessage">
              <v-col cols="12">
                <v-alert :type="statusType" dense outlined>
                  {{ statusMessage }}
                </v-alert>
              </v-col>
            </v-row>

            <!-- Preview Years -->
            <v-row class="tw-mx-4 tw-mt-2" v-if="previewYears.length > 0">
              <v-col cols="12">
                <div class="tw-text-sm tw-text-gray-700">
                  จะสร้าง Time Periods สำหรับปี:
                  <strong>{{ previewYearsDisplay }}</strong>
                </div>
              </v-col>
            </v-row>

          </v-card-text>
          <div
            v-else
            class="align-center justify-center"
            style="height: 200px; display: flex"
          >
            No Permission
          </div>
        </v-card>
      </v-container>
    </v-main>

  </Admin>

</template>

<script>
import Admin from "../../components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import firebase from "firebase/app";
import { mapState } from "vuex";

export default {
  name: "SettingTest",
  components: {
    Admin,
  },

  data: () => ({
    startYear: new Date().getFullYear(),
    numYears: 3,
    numYearsOptions: [1, 2, 3],
    previewYears: [],
    isLoading: false,
    statusMessage: "",
    statusType: "info",
    breadcrumbItems: [
      { text: "ตั้งค่า", disabled: false, to: { name: "Company.Settings" } },
      { text: "เพิ่มปีบัญชี", disabled: true },
    ],
  }),

  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      selectedCompanyProductList: (state) => state.companies.selectedCompanyProductList,
      isProductListLoading: (state) => state.companies.isProductListLoading,
    }),
    companyId() {
      return this.$route.params.companyId;
    },
    previewYearsDisplay() {
      return this.previewYears.map((y) => `${y} (พ.ศ. ${y + 543})`).join(', ');
    },
  },

  created() {
    if (this.companyId) {
      this.$store.dispatch("user/getRoleUser", { companyId: this.companyId });
    }
  },

  methods: {
    handlePreview() {
      this.previewYears = Array.from({ length: this.numYears }, (_, i) => this.startYear + i);
      this.statusMessage = "";
      this.statusType = "info";
    },

    async handleUpload() {
      if (!this.companyId) {
        this.statusMessage = "ไม่พบ Company ID";
        this.statusType = "error";
        return;
      }

      this.isLoading = true;
      this.statusMessage = "";

      try {
        const periods = this.generateTimePeriods(this.startYear, this.numYears);
        const basePath = `/Companies/${this.companyId}/SettingThaiSmartTax/taxTimePeriods/TimePeriods`;

        const chunkSize = 500;
        for (let i = 0; i < periods.length; i += chunkSize) {
          const chunk = periods.slice(i, i + chunkSize);
          const batch = fc.db.batch();

          chunk.forEach((period) => {
            const ref = fc.db.collection(basePath).doc(period.id);
            batch.set(ref, period);
          });

          await batch.commit();
        }

        this.statusMessage = `Upload สำเร็จ ${periods.length} records ไปยัง ${this.selectedCompany.name || this.companyId}`;
        this.statusType = "success";
      } catch (error) {
        console.error("Upload error:", error);
        this.statusMessage = `Upload ล้มเหลว: ${error.message}`;
        this.statusType = "error";
      } finally {
        this.isLoading = false;
      }
    },

    generateTimePeriods(startYear, numYears) {
      const timePeriods = [];
      const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
      const Timestamp = firebase.firestore.Timestamp;

      for (let year = startYear; year < startYear + numYears; year++) {
        timePeriods.push({
          id: `year_${year}`,
          name: `FY ${year}`,
          startDate: Timestamp.fromDate(new Date(Date.UTC(year, 0, 1, 0, 0, 0))),
          endDate: Timestamp.fromDate(new Date(Date.UTC(year, 11, 31, 23, 59, 59))),
          type: "year",
        });

        for (let quarter = 1; quarter <= 4; quarter++) {
          const startMonth = (quarter - 1) * 3;
          const endMonth = startMonth + 2;
          const lastDayQ = new Date(year, endMonth + 1, 0).getDate();

          timePeriods.push({
            id: `quarter_${quarter}_${year}`,
            name: `Q${quarter} ${year}`,
            startDate: Timestamp.fromDate(new Date(Date.UTC(year, startMonth, 1, 0, 0, 0))),
            endDate: Timestamp.fromDate(new Date(Date.UTC(year, endMonth, lastDayQ, 23, 59, 59))),
            parentIndex: `year_${year}`,
            type: "quarter",
          });

          for (let month = startMonth; month <= endMonth; month++) {
            const lastDay = new Date(year, month + 1, 0).getDate();
            timePeriods.push({
              id: `month_${month + 1}_${year}`,
              name: `${months[month]} ${year}`,
              startDate: Timestamp.fromDate(new Date(Date.UTC(year, month, 1, 0, 0, 0))),
              endDate: Timestamp.fromDate(new Date(Date.UTC(year, month, lastDay, 23, 59, 59))),
              parentIndex: `quarter_${quarter}_${year}`,
              type: "month",
            });
          }
        }
      }
      return timePeriods;
    },

  },
};
</script>
